import { Lightbox } from '@3pc/lightbox-photoswipe';
import { $, $$, insertHTML } from 'src/shared/js/utils/dom';
import { config, fixCounter } from 'src/shared/js/modules/lightbox/lightbox';

// Initalize items and sizes for the waterfall layout
const initLightbox = gallery => {
  const children = $$('.slide-item__lightbox-toggle', gallery);
  const lightboxInstance = new Lightbox({
    ...{ gallery, children },
    ...config,
  });

  lightboxInstance.init();
  fixCounter(lightboxInstance);
};

// Initialize waterfall layout
const initWaterFallLayout = async (gallery, items) => {
  const sizes = [
    { columns: 1, gutter: 15 },
    { mq: '768px', columns: 3, gutter: 0 },
  ];
  let Bricks = null;

  // lazy load bricks.js
  await import(/* webpackChunkName: 'bricks' */ 'bricks.js').then(
    _ => (Bricks = _.default)
  );

  const waterfall = new Bricks({
    container: $('.image-gallery__list', gallery),
    sizes,
    position: true,
    packed: 'packed',
  });

  // Add placeholder for image ratio
  const appendRatioPlaceholder = () => {
    const template = `<span class="image-gallery-placeholder"></span>`;

    items.forEach(item => {
      const figure = $('figure', item);
      if (figure) insertHTML(figure, 'afterbegin', template);
    });
  };

  // Calculate placeholder height
  const setPlaceholderHeight = () => {
    items.forEach(item => {
      const placeholder = $('.image-gallery-placeholder', item);

      if (placeholder) {
        const imageSize = $('[data-size]', item).dataset.size;

        const sizes = imageSize.split('x');
        const ratio = parseInt(sizes[0]) / parseInt(sizes[1]);
        placeholder.style.paddingTop = (1 / ratio) * 100 + '%';
      }
    });
  };

  appendRatioPlaceholder();
  setPlaceholderHeight();
  waterfall.pack().resize(true);
  window.addEventListener('resize', () => waterfall.pack(), {
    passive: true,
  });
};

const gridSliders = $$('.image-gallery');
if (gridSliders.length) {
  gridSliders.forEach(gallery => {
    initLightbox(gallery);

    const items = $$('.image-gallery__item', gallery);

    if (!items.length) return;
    initWaterFallLayout(gallery, items);
  });
}
